import React from 'react';
import { Link } from 'react-router-dom';

import {trans} from '../../../../common/utils';
import {inject, observer} from "mobx-react";


const MyFavorites = ({store}) => {
    const isLogged = store.user.isLogged;

    return (
        isLogged ? (
            <Link
                className="prematch__menu-favorites"
                to={`/sport/All/favorites`}
            >
                <i className="prematch__menu-favorites-icon doruk-star-fill" />
                <span>{trans('My Favorites')}</span>
            </Link>
        ) : null
    );
};

export default inject('store')(observer(MyFavorites));
